
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  import GET_USER_POSTING from "@/apollo/jobboard/GetUserPosting.gql";

  import PostingHeader from "@/components/jobboard/PostingHeaderV2.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import InformationWrapper from "@/components/inforationCards/InformationWrapper.vue";
  import InformationCard from "@/components/inforationCards/InformationCard.vue";
  import InformationSection from "@/components/inforationCards/InformationSection.vue";
  import FormattedDescription from "@/components/common/FormattedDescription.vue";
  import Chip from "@/components/filters/Chip.vue";
  import UiButton from "@/components/button/ui-button.vue";

  import RouteNames from "@/entities/RouteNames";
  import { User, Company, Application, Posting } from "@/generated/graphql";
  import { NO_INFORMATION } from "@/data/placeholders";
  import ApplicationNote from "@/components/jobboard/ApplicationNoteV2.vue";
  import ItemChipsData from "@/entities/ItemChipsData";
   import ItemChipsWithMore from "@/components/common/ItemChipsWithMoreCustom.vue";
  import { getPostingDateFormat } from "@/helpers/dateFormat";
  import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";
  import ColorIconContainer from "@/components/icons/ColorIconContainer.vue";
  import DownloadIcon from "@/components/icons/DownloadIcon.vue";
  import LinkIcon from "@/components/icons/LinkIcon.vue";
  import DocumentProvider from "@/components/documents/DocumentProvider.vue";
  import ApplicationAttachment from "@/components/jobboard/ApplicationAttachmentV2.vue";
import ItemsRenderer from "@/components/ItemsRenderer.vue";
import { formatCurrency, getFile } from "@/utils";
import getFormattedDuration from "@/helpers/getFormattedDuration";


  @Component({
    components: {
      ApplicationAttachment,
      DocumentProvider,
      LinkIcon,
      DownloadIcon,
      ItemChipsWithMore,
      ColorIconContainer,
      ModalSectionsDivider,
      ApplicationNote,
      LoadingOverlay,
      PostingHeader,
      InformationWrapper,
      FormattedDescription,
      InformationSection,
      InformationCard,
      Chip,
      UiButton,
      ItemsRenderer
    },
    apollo: {
      posting: {
        query: GET_USER_POSTING,
        variables() {
          return {
            postingId: this.$route.params.id,
            userId: this.currentUser.id,
          };
        },
        update: function (data) {
          return data.posting_by_pk;
        },
      },
    },
  })
  export default class PostingDetails extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    posting: Posting | null = null;

    placeholder: string = NO_INFORMATION;

    routes = RouteNames;
    companyLogo = ''

@Watch('posting')
async setComapnyLogo(){
  this.companyLogo = await this.getCompanyLogo()

}
  get getBudet(): string {
    let budget = "n/a";
    const minrate =this.posting?.min_rate;
    const maxrate = this.posting?.max_rate;
    if (minrate != null) {
      const isDecimal = `${minrate}`.match(/\./g);
      budget = formatCurrency(minrate, { precision: isDecimal ? 2: 0 });
    }
    if (maxrate != null) {
      const isDecimal = `${maxrate}`.match(/\./g);
      budget += `- ${formatCurrency(maxrate, { precision: isDecimal ? 2: 0 })}`;
    }
    return budget;
  }
  get type(): string | undefined {
    return this.posting?.employment_type || undefined;
  }
  get jobDuration(): string | undefined {
    return getFormattedDuration(this.posting?.duration);
  }
    get company(): Company | undefined {
      return this.posting?.company;
    }
      async getCompanyLogo(){
      if(!this.company.company_logo) return ''
      return await getFile(this.company.company_logo)
    }
   get getIsapplied(){
    return !this.application?.is_cancelled && this.application?.created_at
   }
//   get  getSkils(){
// return this.skills.map(s => {
//   if (s.skill) {
//     return s.skill
//   }
//   return s
// })
//     }
//   get  getIndustries(){
// return this.industries.map(s => {
//   if (s.industry) {
//     return s.industry
//   }
//   return s
// })
//     }
    get industries(): ItemChipsData[] {
      return this.posting?.industries?.map(({ industry }) => ({
        id: industry.id,
        name: industry.name,
      }));
    }

    get skills(): ItemChipsData[] {
      return this.posting?.skills?.map(({ skill }) => ({
        id: String(skill.id),
        name: skill.name!,
      }));
    }

    get application(): Application | undefined {
      return this.posting?.applications[0];
    }

    get formattedCreatedAt(): string {
      return getPostingDateFormat(this.posting!.created_at);
    }

    get contractorNote(): string {
      return this.posting?.applications[0]?.note || "";
    }

    get attachmentFileName(): string {
      return this.application?.document?.filename || "";
    }

    get commentsDividerShown(): boolean {
      return Boolean(this.contractorNote) && Boolean(this.attachmentFileName);
    }

    get contractorAddedComment(): boolean {
      return Boolean(this.contractorNote) || Boolean(this.attachmentFileName);
    }

    refetchData(): void {
      this.$apollo.queries.posting.refetch();
    }
  }
